import { trigger } from '@angular/animations';
import { Component, ViewEncapsulation } from '@angular/core';
import { fadeIf } from 'src/app/animations/fade.if.animation';
import { ToastService } from 'src/app/services/toast.service';
import { ButtonDirective } from '../../shared/directives/button.directive';
import { SvgComponent } from '../../shared/components/svg/svg.component';
import { NgFor, NgIf } from '@angular/common';

@Component({
    selector: 'app-toasts',
    templateUrl: './toasts.component.html',
    styleUrls: ['./toasts.component.scss'],
    animations: [trigger('toast', fadeIf)],
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [
        NgFor,
        NgIf,
        SvgComponent,
        ButtonDirective,
    ],
})
export class ToastsComponent {
  constructor(public toastService: ToastService) {}
}
